import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { ApiService } from '../../core/services/api.service';
import { ConsentsAcceptedDialogComponent } from './consents-accepted-dialog/consents-accepted-dialog.component';
import { AnalyticsEvent, AnalyticsService } from '../../core/services/analytics-service';
import { DialogService } from '../../core/services/dialog.service';
import { ToolbarService } from '../../core/services/toolbar.service';

@Injectable({
  providedIn: 'root',
})
export class AccountConsentsService {
  migrationConsentActive: boolean;

  constructor(
    private authService: AuthStoreService,
    private apiService: ApiService,
    private analytics: AnalyticsService,
    private dialog: DialogService,
    private toolbarService: ToolbarService,
  ) {
    this.checkIsMigrationConsentActive();
  }

  async checkIsMigrationConsentActive(): Promise<void> {
    if (this.authService.isAuthenticated) {
      this.migrationConsentActive = !(await this.migrationConsentChecked());
    }
  }

  async migrationConsentChecked(): Promise<boolean> {
    return this.apiService
      .get<boolean>(`/customers/${this.authService.userInfo.customer_id}/migration-consents`)
      .toPromise();
  }

  public updateMigrationConsents(formValue: { migrationConsent: boolean; marketingConsent: boolean }): void {
    this.apiService
      .put(`/customers/${this.authService.userInfo.customer_id}/migration-consents`, formValue)
      .pipe(
        switchMap(() =>
          this.dialog
            .open(ConsentsAcceptedDialogComponent, {
              maxWidth: 524,
            })
            .afterClosed()
            .pipe(tap(()=>   this.checkIsMigrationConsentActive())),
        ),
        tap(() => {
          this.analytics.trackEvent(new AnalyticsEvent('Migration consent enabled'));
          this.toolbarService.resize$.next(null);
        }),
      )
      .subscribe();
  }
}
